import React from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useTheme, View } from '@annunciate/ui';
import { useDiscussionQuery } from '../hooks';
import { Comments } from './Comments';
export const Discussion = ({ id, endpoint, depth, }) => {
    const theme = useTheme();
    const { isPending, error, data } = useDiscussionQuery({
        externalId: id,
        endpoint,
    });
    return (React.createElement(View, { style: { marginTop: 30 } },
        React.createElement(React.Fragment, null,
            (isPending && !error) ? (React.createElement(View, { style: { marginHorizontal: 10 } },
                React.createElement(Text, null, "Loading comments"),
                React.createElement(LinearProgress, { animation: { duration: 5000 }, style: { marginVertical: 10 } }))) : null,
            error ? (React.createElement(View, { style: {
                    backgroundColor: theme.colors?.error,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    marginVertical: 5,
                    borderRadius: 10,
                } },
                React.createElement(Text, { style: { textAlign: 'center' } }, "There was an error loading the comments. Please contact support."))) : null,
            !isPending && !error ? (React.createElement(Comments, { discussionId: data?.Discussion?.id, endpoint: endpoint, depth: 1, maxDepth: depth, displayMeta: true, displayCreate: true })) : null)));
};
//# sourceMappingURL=Discussion.js.map